module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-art-screen.96eca493.jpg";